import { combineReducers } from 'redux';
import Set from './set_reducer';

export default combineReducers({
  Set,
});



// WEBPACK FOOTER //
// ./frontend/reducers/root_reducer.jsx